import { FC } from "react";
import { ImageType } from "../helpers/useImages";
import ModalBuy from "./ModalBuy";

const BuyBox: FC<{ image: ImageType }> = ({ image }) => {
  return (
    <div className="buy-box">
      <div className="top">
        <span>№ {image.id}</span>
        <div>
          <span>{image.resolution} п/д</span>
          <span>
            {image.sizes.widthSM}x{image.sizes.heightSM} см
          </span>
          <span>{image.format}</span>
        </div>
      </div>
      <div className={"bottom"}>
        <div className={"price"}>{image.price} р.</div>
        <ModalBuy image={image} />
      </div>
    </div>
  );
};

export default BuyBox;
